import {
  GET_THERMAL_STABILITY_TEST_FAILURE,
  GET_THERMAL_STABILITY_TEST_REQUEST,
  GET_THERMAL_STABILITY_TEST_SUCCESS,
} from "./thermalStabilityTestATypes";

const initialState = {
  loading: false,
  thermalStabilityTest: [],
  error: "",
};

const getThermalStabilityTestReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_THERMAL_STABILITY_TEST_REQUEST:
      return {
        ...state,
        loading: true,
      };
      
    case GET_THERMAL_STABILITY_TEST_SUCCESS:
      return {
        loading: false,
        thermalStabilityTest: action.payload,
        error: "",
      };
      
    case GET_THERMAL_STABILITY_TEST_FAILURE:
      return {
        loading: false,
        thermalStabilityTest: [],
        error: action.payload,
      };
      
    default:
      return state;
  }
};

export { getThermalStabilityTestReducer };